import { StoryblokRichTextNode } from "@storyblok/richtext";
import { escapeHtml, sanitizeUrl } from "./sanitize";

// Extended node type that includes marks (not exposed in the library's types)
export interface StoryblokRichTextNodeWithMarks extends StoryblokRichTextNode<string> {
  marks?: Array<{
    type: string;
    attrs?: {
      href?: string;
      target?: string;
      [key: string]: unknown;
    };
  }>;
}

/**
 * Custom image resolver that supports link marks on native rich text images.
 * The default Storyblok resolver ignores marks on images,
 * so we need to handle them explicitly.
 */
export const renderImage = (node: StoryblokRichTextNode): string => {
  const nodeWithMarks = node as StoryblokRichTextNodeWithMarks;
  const { src, alt } = node.attrs || {};

  const sanitizedSrc = sanitizeUrl(src);
  if (!sanitizedSrc) return "";

  const imgTag = `<img src="${sanitizedSrc}" alt="${escapeHtml(alt)}" loading="lazy" />`;

  // Check if the image has a link mark
  const linkMark = nodeWithMarks.marks?.find((mark) => mark.type === "link");

  if (linkMark) {
    const href = sanitizeUrl(linkMark.attrs?.href);
    const target = linkMark.attrs?.target || "_self";
    const rel = target === "_blank" ? ' rel="noopener noreferrer"' : "";

    return `<a href="${href}" target="${target}"${rel}>${imgTag}</a>`;
  }

  return imgTag;
};
